import { useState } from "react";

import { strCode } from "../../consts";
import { log, notificationService, releaseNotesService, t } from "../../services";

export const useDeleteReleaseNotes = () => {
  const [loading, setLoading] = useState(false);

  const mutationCallback = async (version) => {
    try {
      setLoading(true);

      await releaseNotesService.deleteReleaseNotes(version);
    } catch (error) {
      log.error("useDeleteReleaseNotes: Failed to delete release notes", error);
      notificationService.showError({
        title: t(strCode.DELETE_RELEASE_NOTES_ERROR),
        message: error?.response?.data?.message ? error.response.data.message : error?.toString()
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
